var _path, _path2, _mask, _g, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.505 20.4l8.114 2.174-3.106 11.591-3.058-4.813-5.055 2.64L5.505 20.4z",
    fill: "#F80032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.914 20.4L10.8 22.574l3.106 11.591 3.059-4.813 5.055 2.64L18.914 20.4z",
    fill: "#C60028"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "badge-gold_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#badge-gold_svg__filter0_i_3994_9246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
    fill: "#A99415"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24H0zm24 13c0 6.627-5.373 12-12 12S0 19.627 0 13v-1c0 6.075 5.373 11 12 11s12-4.925 12-11v1zM0 24V0v24zM24 0v24V0z",
    fill: "#BFA406",
    mask: "url(#badge-gold_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 16.84h8v1.96h-8v-1.96zm3.953-8.96a4.215 4.215 0 012.009.467c.585.311.878.899.878 1.762v3.287c0 .228.005.504.013.828-.005.174.032.346.107.5a.65.65 0 00.266.217v.276h-1.959a2.154 2.154 0 01-.114-.408 4.81 4.81 0 01-.05-.434 3.728 3.728 0 01-.86.715 2.506 2.506 0 01-1.314.35 2.204 2.204 0 01-1.545-.555 2.024 2.024 0 01-.61-1.575c-.046-.791.336-1.539.98-1.914a4.218 4.218 0 011.58-.46l.613-.079c.244-.022.484-.077.714-.164a.56.56 0 00.386-.532.64.64 0 00-.294-.608 1.772 1.772 0 00-.863-.168c-.33-.037-.66.083-.903.329-.138.19-.225.417-.253.657H9.395c.016-.56.193-1.1.506-1.546.476-.63 1.293-.945 2.452-.945zm1.086 3.853c-.109.072-.224.132-.344.18-.156.057-.315.1-.477.128l-.405.08a2.535 2.535 0 00-.815.256.867.867 0 00-.417.795.857.857 0 00.258.693c.179.146.398.22.622.213.382.002.755-.121 1.071-.354.326-.237.496-.669.509-1.295l-.002-.697zM16.4 4.8v1.96h-8V4.8h8z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75 23.25 5.787 23.25 12z",
    stroke: "#DABD14",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "badge-gold_svg__filter0_i_3994_9246",
    x: 0,
    y: 0,
    width: 24,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3994_9246"
  })))));
}

export default SvgBadgeGold;